import { graphql } from "gatsby"
import React from "react"
import FullFeature from "../feature/FullFeature"
import FullProduct from "../product/FullProduct"
import FullStaticImage from "../staticImage/FullStaticImage"
import FullVideo from "../video/FullVideo"
import FullCommercial from "../commercial/FullCommercial"

export interface IProductFooter {
  headline: string
  link: {
    target: string
    title: string
    url: string
  }
}

export interface IFullProductProps {
  backgroundImage: IImageData
  button: any
  buttonLabel: string
  fieldGroupName: string
  icon: IImageData

  footer?: IProductFooter
  product: IProduct
}
export interface IFullCommercialProps {
  subHeadline: string
  collection: any
  logos: any
  button: any
  backgroundImage: any
}

export interface IProduct {
  link: string
  acfProduct: any
  product: {
    description: string
    variants: any
    title: string
  }
}

export interface IFullStaticImageProps {
  backgroundImage: any
  footer?: IProductFooter
}

export interface IFullFeatureProps {
  backgroundImage: IImageData
  button: {
    target: string
    title: string
    url: string
  }
  description: string
  fieldGroupName: string
  headline: string
  icon: IImageData
  subHeadline: string
  footer?: IProductFooter
}

export interface IFullVideoProps {
  fieldGroupName: string
  playIcon: IImageData
  videoEmbedUrl: string
  footer?: IProductFooter
  videoThumbNail: IImageData
}

interface IFullWidthPromoModulesProps {
  blocks:
    | IFullProductProps
    | IFullStaticImageProps
    | IFullVideoProps
    | IFullFeatureProps[]
}

const FullWidthPromoModules: React.FC<IFullWidthPromoModulesProps> = ({
  blocks,
}) => {
  if (!blocks || !blocks[0]) return null

  const promoType =
    blocks[0].fieldGroupName && blocks[0].fieldGroupName.split("_").slice(-1)[0]

  switch (promoType) {
    case "Product":
      return <FullProduct {...blocks[0]} />

    case "StaticImage":
      return <FullStaticImage {...blocks[0]} />

    case "Feature":
      return <FullFeature {...blocks[0]} />

    case "Video":
      return <FullVideo {...blocks[0]} />

    case "Commercial":
      return <FullCommercial {...blocks[0]} />

    default:
      return null
  }
}

export default FullWidthPromoModules

export const fragment = graphql`
  fragment FullWidthPromoModules on WpDefaultTemplate_Acf_Modules {
    ... on WpDefaultTemplate_Acf_Modules_Promos {
      promos {
        ...FullFeature
        ...FullVideo
        ...FullProduct
        ...FullStaticImage
        ...FullCommercial
      }
    }
  }
`
